import "../../../chunk-D57E6H3M.mjs";

// src/components/composite/Conversations/utils.ts
import { isMessageFeedbackReason } from "../../../domain/index.mjs";
var ENGLISH_ANONYMOUS_NAMES = { visitor: "Anonymous visitor", user: "Anonymous user" };
function conversationKey(group) {
  return "visitorID" in group ? `website:${group.visitorID ?? group.sessions[0]?.id ?? "anonymous"}` : `${group.channel}:${group.userIdentifier ?? group.sessions[0]?.id ?? "anonymous"}`;
}
function conversationChannel(group) {
  return "visitorID" in group ? "website" : group.channel;
}
function conversationName(group, anonymous = ENGLISH_ANONYMOUS_NAMES) {
  return group.displayName || ("visitorID" in group ? group.customerEmail || anonymous.visitor : group.userIdentifier || anonymous.user);
}
function matchesConversation(group, search, anonymous) {
  const text = [conversationName(group, anonymous), ...group.sessions.flatMap((session) => [session.id, session.type, session.subject, ...session.chatMessage.map((message) => message.content)])].join(" ");
  return text.toLocaleLowerCase().includes(search.trim().toLocaleLowerCase());
}
function storeOrigin(domain) {
  if (!domain) return void 0;
  return /^https?:\/\//i.test(domain) ? domain : `https://${domain}`;
}
function fileTypeCue(fileName) {
  const extension = /\.([a-z0-9]{1,5})$/i.exec(fileName ?? "")?.[1];
  return extension?.toUpperCase();
}
function tokenUsageText(usage, t, locale) {
  const format = (value) => value.toLocaleString(locale);
  return [
    usage.inputTokens !== void 0 && t("shared.chat.token_usage.input", { value: format(usage.inputTokens) }),
    usage.cachedTokens !== void 0 && t("shared.chat.token_usage.cached", { value: format(usage.cachedTokens) }),
    usage.outputTokens !== void 0 && t("shared.chat.token_usage.output", { value: format(usage.outputTokens) }),
    usage.reasoningTokens !== void 0 && t("shared.chat.token_usage.reasoning", { value: format(usage.reasoningTokens) }),
    usage.totalTokens !== void 0 && t("shared.chat.token_usage.total", { value: format(usage.totalTokens) })
  ].filter(Boolean).join(" \xB7 ");
}
function totalTokenUsage(group) {
  const total = {};
  for (const session of group.sessions) {
    for (const message of session.chatMessage) {
      const usage = message.metadata?.tokenUsage;
      if (!usage) continue;
      for (const key of ["inputTokens", "cachedTokens", "outputTokens", "reasoningTokens", "totalTokens"]) {
        if (usage[key] !== void 0) total[key] = (total[key] ?? 0) + usage[key];
      }
    }
  }
  return total;
}
function feedbackLabel(message, t) {
  if (message.feedback === "like") return t("shared.chat.log.feedback.like");
  return isMessageFeedbackReason(message.feedbackReason) ? t("shared.chat.log.feedback.dislike_reason", { reason: t(`chatMessage.dislikeReasons.${message.feedbackReason}`) }) : t("shared.chat.log.feedback.dislike");
}
export {
  conversationChannel,
  conversationKey,
  conversationName,
  feedbackLabel,
  fileTypeCue,
  matchesConversation,
  storeOrigin,
  tokenUsageText,
  totalTokenUsage
};
//# sourceMappingURL=utils.mjs.map